<template>
  <v-dialog v-model="showDialog" persistent max-width="1200px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
      </v-card-title>-->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones tipo producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formUsuario" :v-model="true" lazy-validation>
            <v-tabs icons-and-text dark color="darken">
              <v-tabs-slider color="blue"></v-tabs-slider>
              <v-tab href="#tab-generales">
                Generales
                <v-icon>assignment_ind</v-icon>
              </v-tab>
              <v-tab href="#tab-sucursales">
                Sucursales
                <v-icon>business</v-icon>
              </v-tab>
              <v-tab href="#tab-privilegios">
                Privilegios
                <v-icon>security</v-icon>
              </v-tab>
              <v-tab-item value="tab-generales">
                <v-layout wrap class="container">
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      label="Usuario"
                      v-model="usuario.aliasUsuario"
                      :rules="[
                        () => !!usuario.aliasUsuario || 'El campo es requerido',
                      ]"
                      placeholder="Usuario para ingresar al sistema"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      :append-icon="
                        showPassword1 ? 'visibility' : 'visibility_off'
                      "
                      :rules="[rules.required, rules.min]"
                      :type="showPassword1 ? 'text' : 'password'"
                      name="input-10-2"
                      label="Contraseña"
                      hint="Por lo menos 8 caracteres"
                      prepend-icon="lock"
                      v-model="usuario.password"
                      @click:append="showPassword1 = !showPassword1"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      :append-icon="
                        showPassword2 ? 'visibility' : 'visibility_off'
                      "
                      :rules="[rules.required, rules.min, rules.match]"
                      :type="showPassword2 ? 'text' : 'password'"
                      name="input-10-2"
                      label="Confirmar contraseña"
                      hint="Por lo menos 8 caracteres"
                      prepend-icon="lock"
                      v-model="password2"
                      @click:append="showPassword2 = !showPassword2"
                    ></v-text-field>
                  </v-flex>

                   <v-flex xs12 sm12 md6>
                    <v-text-field
                      :rules="[rules.required, rules.maxPin]"
                      type="text"
                      maxlength="5"
                      label="PIN de acceso público"
                      hint="Escribe por lo menos 5 números"
                      prepend-icon="lock"
                      v-model="usuario.pinAccesoPublico"
                      mask="#####"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      label="Nombre completo"
                      v-model="usuario.nombreCompleto"
                      placeholder="Nombre y apellidos del usuario"
                      :rules="[
                        () =>
                          !!usuario.nombreCompleto || 'El campo es requerido',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Correo electrónico"
                      v-model="usuario.email"
                      placeholder="Correo electrónico del usuario"
                      :rules="[
                        () => !!usuario.email || 'El campo es requerido',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      label="Teléfono de contacto"
                      v-model="usuario.telefono"
                      placeholder="Teléfono o celular del usuario"
                      mask="(###) ### - ####"
                      return-masked-value
                      :rules="[
                        () => !!usuario.telefono || 'El campo es requerido',
                      ]"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-select
                      v-model="usuario.sexo"
                      :items="sexos"
                      item-text="descripcion"
                      item-value="sexo"
                      label="Sexo"
                      placeholder="Sexo"
                      persistent-hint
                      single-line
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-select
                      v-model="usuario.usuarioRolId"
                      :items="roles"
                      item-text="nombreRol"
                      item-value="usuarioRolId"
                      label="Rol de usuario"
                      placeholder="Rol de usuario"
                      persistent-hint
                      single-line
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md6></v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item value="tab-sucursales">
                <v-toolbar-title class="ml-3 pl-3 pt-3">
                  <span class="hidden-sm-and-down"
                    >SELECCIONA LAS SUCURSALES A LAS QUE EL USUARIO TIENE
                    ACCESO</span
                  >
                </v-toolbar-title>
                <v-layout wrap class="container">
                  <v-flex
                    xs12
                    sm4
                    md4
                    v-for="sucursal in sucursales"
                    :key="sucursal.sucursalId"
                  >
                    <v-switch
                      v-model="sucursalesUsuario"
                      :label="sucursal.nombreSucursal"
                      color="success"
                      :value="sucursal.sucursalId"
                      hide-details
                      @change="addOrDeleteSucursal"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </v-tab-item>
              <v-tab-item value="tab-privilegios">
                <v-toolbar-title class="ml-3 pl-3 pt-3">
                  <span class="hidden-sm-and-down"
                    >SELECCIONA LOS PRIVILEGIOS DEL USUARIO</span
                  >
                </v-toolbar-title>
                <v-layout wrap class="container">
                  <v-flex xs6 sm6>
                    <v-btn color="primary darken-4" @click="darPrivilegios"
                      >Seleccionar todos</v-btn
                    >
                  </v-flex>
                  <v-flex xs6 sm6>
                    <v-btn color="primary darken-4" @click="quitarPrivilegios"
                      >Deseleccionar todos</v-btn
                    >
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.iniciarSesion"
                      :label="`Iniciar sesión`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>USUARIOS</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.usuarioAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.usuarioModificar"
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.usuarioEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.usuarioConsultar"
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.usuariosConsultar"
                      :label="`Consultar todos`"
                    ></v-checkbox>

                    <v-subheader>
                      <b>SUCURSALES</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.sucursalAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.sucursalModificar"
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.sucursalEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.sucursalConsultar"
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.sucursalesConsultar"
                      :label="`Consultar todas`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>CLIENTES</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.clienteAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.clienteModificar"
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.clienteEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.clienteConsultar"
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.clientesConsultar"
                      :label="`Consultar todos`"
                    ></v-checkbox>

                    <v-subheader>
                      <b>PARAMETROS EMPRESA</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.parametrosEmpresaModificar
                      "
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.parametrosEmpresaConsultar
                      "
                      :label="`Consultar`"
                    ></v-checkbox>

                    <v-subheader>
                      <b>DISPONIBILIDAD SKU</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.disponibilidadConsulta
                      "
                      :label="`Consultar`"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm3 md3>
                    <v-subheader>
                      <b>COLORES PRODUCTO</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.colorProductoAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.colorProductoModificar
                      "
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.colorProductoEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.colorProductoConsultar
                      "
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.coloresProductosConsultar
                      "
                      :label="`Consultar todos`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>LÍNEAS PRODUCTO</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.lineaProductoAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.lineaProductoModificar
                      "
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.lineaProductoEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.lineaProductoConsultar
                      "
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.lineasProductoConsultar
                      "
                      :label="`Consultar todos`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>MARCAS PRODUCTO</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.marcaProductoAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.marcaProductoModificar
                      "
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.marcaProductoEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.marcaProductoConsultar
                      "
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.marcasProductoConsultar
                      "
                      :label="`Consultar todos`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>TALLAS PRODUCTO</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.tallaProductoAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.tallaProductoModificar
                      "
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.tallaProductoEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.tallaProductoConsultar
                      "
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.tallasProductoConsultar
                      "
                      :label="`Consultar todas`"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm3 md3>
                    <v-subheader>
                      <b>RENTAS</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaModificar"
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaCancelar"
                      :label="`Cancelar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentasConsultar"
                      :label="`Consultar todas`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaConsultar"
                      :label="`Consultar detalle`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaGenerarTicket"
                      :label="`Generar Ticket`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaAgregarBitacora"
                      :label="`Agregar datos a bitácora`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.rentaConsultarBitacora
                      "
                      :label="`Consultar bitácora`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaConsultarPagos"
                      :label="`Consultar pagos`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaAgregarPagos"
                      :label="`Agregar pagos`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaModificarPagos"
                      :label="`Modificar pagos`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentaEliminarPagos"
                      :label="`Eliminar pagos`"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.rentasCorte"
                      :label="`Realizar Corte`"
                    ></v-checkbox>

                    <v-subheader>
                      <b>VENTAS</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.ventaAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.ventaModificar"
                      :label="`Modificar entrega`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.ventaEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.ventaConsultar"
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.ventaGenerarTicket"
                      :label="`Generar Ticket`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.ventasConsultar"
                      :label="`Consultar todas`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.ventasCorte"
                      :label="`Realizar Corte`"
                    ></v-checkbox>

                    <v-subheader>
                      <b>PRECIOS PRODUCTO</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.preciosProductoConsulta
                      "
                      :label="`Consultar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.preciosProductoModificar
                      "
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>INVENTARIO PRODUCTO</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.inventarioProductoAgregar
                      "
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.inventarioProductoModificar
                      "
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.inventarioProductoConsulta
                      "
                      :label="`Consultar`"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm3 md3>
                    <v-subheader>
                      <b>PRODUCTOS</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.productoAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.productoModificar"
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.productoEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.productoConsultar"
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.productosConsultar"
                      :label="`Consultar todos`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.productosFotosAgregar"
                      :label="`Agregar fotos`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.productosFotosModificar
                      "
                      :label="`Modificar fotos`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.productosFotosEliminar
                      "
                      :label="`Eliminar fotos`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.productosFotosConsultar
                      "
                      :label="`Consultar fotos`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>CONJUNTOS</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.conjuntoAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.conjuntoModificar"
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.conjuntoEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.conjuntoConsultar"
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.conjuntosConsultar"
                      :label="`Consultar todos`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.conjuntoProductoAgregar
                      "
                      :label="`Asignar producto`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.conjuntoProductoEliminar
                      "
                      :label="`Quitar producto`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.conjuntoProductoConsultar
                      "
                      :label="`Consultar productos`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>CATALOGO PRODUCTOS</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.catalogoProductoAgregar
                      "
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.catalogoProductoModificar
                      "
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.catalogoProductoEliminar
                      "
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.catalogoProductoConsultar
                      "
                      :label="`Consultar`"
                    ></v-checkbox>
                    <v-subheader>
                      <b>TIPOS PRODUCTO</b>
                    </v-subheader>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.tipoProductoAgregar"
                      :label="`Agregar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.tipoProductoModificar"
                      :label="`Modificar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.tipoProductoEliminar"
                      :label="`Eliminar`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="usuario.privilegiosUsuario.tipoProductoConsultar"
                      :label="`Consultar detalle`"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="
                        usuario.privilegiosUsuario.tiposProductoConsultar
                      "
                      :label="`Consultar todas`"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-tab-item>
            </v-tabs>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveUsuario"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
        >{{ mensajeUsuario }}</v-alert
      >
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
    <snack-bar></snack-bar>
  </v-dialog>
</template>

<script>
//GLOBAL COMPONENTS
import snackBar from "@/components/SnackBar";

//SERVICES
import usuarioRolService from "@/services/usuarioRolService";
import usuarioService from "@/services/usuarioService";
import sucursalService from "@/services/sucursalService";

export default {
  components: {
    snackBar,
  },
  props: {
    usuario: {
      type: Object,
    },
  },
  watch: {
    usuario: function (n) {
      this.password2 = n.password;
      this.passwordAnterior = n.password;
    },
  },
  data() {
    return {
      showDialog: false,
      showPassword1: false,
      showPassword2: false,
      passwordAnterior: "",
      password2: "",
      rules: {
        required: (value) => !!value || "El valor es requerido.",
        maxPin: (v) => v.length == 5 || "El pin debe ser de 5 digitos numéricos ",
        onlyNumbers: (v) => v.match("/\d+/g") || "El pin debe ser numérico ",
        min: (v) => v.length >= 8 || "Mínimo 8 caracteres",
        match: (v) =>
          v === this.usuario.password || "Las contraseñas deben coincidir",
      },
      sexos: [
        {
          sexo: "M",
          descripcion: "Masculino",
        },
        {
          sexo: "F",
          descripcion: "Femenino",
        },
      ],
      roles: [],
      sucursales: [],
      mensajeUsuario: "",
      sucursalesUsuario: [],
    };
  },
  methods: {
    openDialog() {
      this.getRoles();
      this.getSucursales();
      this.showDialog = true;
    },
    getRoles() {
      let self = this;

      usuarioRolService
        .getRoles()
        .then((result) => {
          self.roles = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getSucursales() {
      let self = this;

      sucursalService
        .getAllForDrop()
        .then((result) => {
          self.sucursales = result;
          self.getSucursalesUsuario();
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getSucursalesUsuario() {
      let sucursalesId = [];

      this.usuario.sucursalesUsuario.forEach((s) => {
        sucursalesId.push(s.sucursalId);
      });

      this.sucursalesUsuario = sucursalesId;
    },
    saveUsuario() {
      let self = this;

      if (self.$refs.formUsuario.validate()) {
        self.operationStart();

        if (self.usuario.usuarioId === "") {
          self.addUsuario();
        } else {
          self.updateUsuario();
        }
      }
    },
    addUsuario() {
      let self = this;
      self.usuario.password = Sha256.hash(self.usuario.password);
      self.password2 = Sha256.hash(self.usuario.password);

      usuarioService
        .add(self.usuario)
        .then((result) => {
          self.mensajeUsuario = "Usuario guardado con éxito";
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onUsuarioAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 1500);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateUsuario() {
      let self = this;

      let passwordSHA;
      if (self.passwordAnterior !== self.usuario.password) {
        self.usuario.password = Sha256.hash(self.usuario.password);
        self.password2 = Sha256.hash(self.usuario.password);
      }

      usuarioService
        .update(self.usuario)
        .then((result) => {
          self.mensajeUsuario = "Usuario guardado con éxito";

          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onUsuarioUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    resetForm() {
      this.usuario.usuarioId = "";
      this.usuario.aliasUsuario = "";
      this.usuario.password = "";
      this.usuario.nombreCompleto = "";
      this.usuario.email = "";
      this.usuario.telefono = "";
      this.usuario.sexo = "";
      this.usuario.usuarioRolId = 0;
      this.usuario.privilegiosJson = "";
      this.usuario.privilegios = {};
      this.password2 = "";
      this.passwordAnterior = "";
      this.pinAccesoPublico = "";
      (this.usuario.privilegiosUsuario = {
        iniciarSesion: false,
        usuarioAgregar: false,
        usuarioModificar: false,
        usuarioEliminar: false,
        usuarioConsultar: false,
        usuariosConsultar: false,
        sucursalesConsultar: false,
        sucursalConsultar: false,
        sucursalAgregar: false,
        sucursalModificar: false,
        sucursalEliminar: false,
      }),
        (this.usuario.sucursalesUsuario = []);
      this.operationReset();
      this.$refs.formUsuario.resetValidation();
    },
    addOrDeleteSucursal(s) {
      //console.log(s);
      //console.log(this.usuario.sucursalesUsuario);
      this.usuario.sucursalesUsuario.length = 0;
      s.forEach((i) => {
        this.usuario.sucursalesUsuario.push({
          sucursalId: i,
          nombreSucursal: "",
        });
      });
    },
    darPrivilegios() {
      this.usuario.privilegiosUsuario.iniciarSesion = true;
      this.usuario.privilegiosUsuario.usuarioAgregar = true;
      this.usuario.privilegiosUsuario.usuarioModificar = true;
      this.usuario.privilegiosUsuario.usuarioEliminar = true;
      this.usuario.privilegiosUsuario.usuarioConsultar = true;
      this.usuario.privilegiosUsuario.usuariosConsultar = true;
      this.usuario.privilegiosUsuario.sucursalesConsultar = true;
      this.usuario.privilegiosUsuario.sucursalConsultar = true;
      this.usuario.privilegiosUsuario.sucursalAgregar = true;
      this.usuario.privilegiosUsuario.sucursalModificar = true;
      this.usuario.privilegiosUsuario.sucursalEliminar = true;

      this.usuario.privilegiosUsuario.sucursalesConsultar = true;
      this.usuario.privilegiosUsuario.sucursalConsultar = true;
      this.usuario.privilegiosUsuario.sucursalAgregar = true;
      this.usuario.privilegiosUsuario.sucursalModificar = true;
      this.usuario.privilegiosUsuario.sucursalEliminar = true;

      //Rentas
      this.usuario.privilegiosUsuario.rentaAgregar = true;
      this.usuario.privilegiosUsuario.rentaModificar = true;
      this.usuario.privilegiosUsuario.rentaCancelar = true;
      this.usuario.privilegiosUsuario.rentaEliminar = true;
      this.usuario.privilegiosUsuario.rentaConsultar = true;
      this.usuario.privilegiosUsuario.rentaAgregarBitacora = true;
      this.usuario.privilegiosUsuario.rentaConsultarBitacora = true;
      this.usuario.privilegiosUsuario.rentaConsultarPagos = true;
      this.usuario.privilegiosUsuario.rentaAgregarPagos = true;
      this.usuario.privilegiosUsuario.rentaModificarPagos = true;
      this.usuario.privilegiosUsuario.rentaEliminarPagos = true;
      this.usuario.privilegiosUsuario.rentasConsultar = true;
      this.usuario.privilegiosUsuario.rentasCorte = true;
      this.usuario.privilegiosUsuario.rentaGenerarTicket = true;

      //VENTAS
      this.usuario.privilegiosUsuario.ventaAgregar = true;
      this.usuario.privilegiosUsuario.ventaModificar = true;
      this.usuario.privilegiosUsuario.ventaEliminar = true;
      this.usuario.privilegiosUsuario.ventaConsultar = true;
      this.usuario.privilegiosUsuario.ventaGenerarTicket = true;
      this.usuario.privilegiosUsuario.ventasConsultar = true;
      this.usuario.privilegiosUsuario.ventasCorte = true;

      //PRODUCTOS
      this.usuario.privilegiosUsuario.productoAgregar = true;
      this.usuario.privilegiosUsuario.productoModificar = true;
      this.usuario.privilegiosUsuario.productoEliminar = true;
      this.usuario.privilegiosUsuario.productoConsultar = true;
      this.usuario.privilegiosUsuario.productosConsultar = true;
      this.usuario.privilegiosUsuario.productosFotosAgregar = true;
      this.usuario.privilegiosUsuario.productosFotosEliminar = true;
      this.usuario.privilegiosUsuario.productosFotosModificar = true;
      this.usuario.privilegiosUsuario.productosFotosConsultar = true;

      //CATALOGO PRODUCTOS
      this.usuario.privilegiosUsuario.catalogoProductoAgregar = true;
      this.usuario.privilegiosUsuario.catalogoProductoModificar = true;
      this.usuario.privilegiosUsuario.catalogoProductoEliminar = true;
      this.usuario.privilegiosUsuario.catalogoProductoConsultar = true;

      //PRECIOS PRODUCTO
      this.usuario.privilegiosUsuario.preciosProductoConsulta = true;
      this.usuario.privilegiosUsuario.preciosProductoModificar = true;

      //INVENTARIO PRODUCTO
      this.usuario.privilegiosUsuario.inventarioProductoAgregar = true;
      this.usuario.privilegiosUsuario.inventarioProductoModificar = true;
      this.usuario.privilegiosUsuario.inventarioProductoConsulta = true;

      //DISPONIBILIDAD
      this.usuario.privilegiosUsuario.disponibilidadConsulta = true;

      //CONJUNTOS
      this.usuario.privilegiosUsuario.conjuntoAgregar = true;
      this.usuario.privilegiosUsuario.conjuntoModificar = true;
      this.usuario.privilegiosUsuario.conjuntoEliminar = true;
      this.usuario.privilegiosUsuario.conjuntoConsultar = true;
      this.usuario.privilegiosUsuario.conjuntosConsultar = true;
      this.usuario.privilegiosUsuario.conjuntoProductoAgregar = true;
      this.usuario.privilegiosUsuario.conjuntoProductoEliminar = true;
      this.usuario.privilegiosUsuario.conjuntoProductoConsultar = true;

      //CLIENTES
      this.usuario.privilegiosUsuario.clienteAgregar = true;
      this.usuario.privilegiosUsuario.clienteModificar = true;
      this.usuario.privilegiosUsuario.clienteEliminar = true;
      this.usuario.privilegiosUsuario.clienteConsultar = true;
      this.usuario.privilegiosUsuario.clientesConsultar = true;

      //PARAMETROS EMPRESA
      this.usuario.privilegiosUsuario.parametrosEmpresaModificar = true;
      this.usuario.privilegiosUsuario.parametrosEmpresaConsultar = true;

      //OTROS CATÁLOGOS - Colores producto
      this.usuario.privilegiosUsuario.colorProductoAgregar = true;
      this.usuario.privilegiosUsuario.colorProductoModificar = true;
      this.usuario.privilegiosUsuario.colorProductoEliminar = true;
      this.usuario.privilegiosUsuario.colorProductoConsultar = true;
      this.usuario.privilegiosUsuario.coloresProductosConsultar = true;

      //OTROS CATÁLOGOS - Líneas producto
      this.usuario.privilegiosUsuario.lineaProductoAgregar = true;
      this.usuario.privilegiosUsuario.lineaProductoModificar = true;
      this.usuario.privilegiosUsuario.lineaProductoEliminar = true;
      this.usuario.privilegiosUsuario.lineaProductoConsultar = true;
      this.usuario.privilegiosUsuario.lineasProductoConsultar = true;

      //OTROS CATÁLOGOS - Marcas producto
      this.usuario.privilegiosUsuario.marcaProductoAgregar = true;
      this.usuario.privilegiosUsuario.marcaProductoModificar = true;
      this.usuario.privilegiosUsuario.marcaProductoEliminar = true;
      this.usuario.privilegiosUsuario.marcaProductoConsultar = true;
      this.usuario.privilegiosUsuario.marcasProductoConsultar = true;

      //OTROS CATÁLOGOS - Marcas producto
      this.usuario.privilegiosUsuario.tallaProductoAgregar = true;
      this.usuario.privilegiosUsuario.tallaProductoModificar = true;
      this.usuario.privilegiosUsuario.tallaProductoEliminar = true;
      this.usuario.privilegiosUsuario.tallaProductoConsultar = true;
      this.usuario.privilegiosUsuario.tallasProductoConsultar = true;

      //OTROS CATÁLOGOS - Tipos Producto
      this.usuario.privilegiosUsuario.tipoProductoAgregar = true;
      this.usuario.privilegiosUsuario.tipoProductoModificar = true;
      this.usuario.privilegiosUsuario.tipoProductoEliminar = true;
      this.usuario.privilegiosUsuario.tipoProductoConsultar = true;
      this.usuario.privilegiosUsuario.tiposProductoConsultar = true;
    },
    quitarPrivilegios() {
      this.usuario.privilegiosUsuario.iniciarSesion = false;
      this.usuario.privilegiosUsuario.usuarioAgregar = false;
      this.usuario.privilegiosUsuario.usuarioModificar = false;
      this.usuario.privilegiosUsuario.usuarioEliminar = false;
      this.usuario.privilegiosUsuario.usuarioConsultar = false;
      this.usuario.privilegiosUsuario.usuariosConsultar = false;
      this.usuario.privilegiosUsuario.sucursalesConsultar = false;
      this.usuario.privilegiosUsuario.sucursalConsultar = false;
      this.usuario.privilegiosUsuario.sucursalAgregar = false;
      this.usuario.privilegiosUsuario.sucursalModificar = false;
      this.usuario.privilegiosUsuario.sucursalEliminar = false;

      this.usuario.privilegiosUsuario.sucursalesConsultar = false;
      this.usuario.privilegiosUsuario.sucursalConsultar = false;
      this.usuario.privilegiosUsuario.sucursalAgregar = false;
      this.usuario.privilegiosUsuario.sucursalModificar = false;
      this.usuario.privilegiosUsuario.sucursalEliminar = false;

      //Rentas
      this.usuario.privilegiosUsuario.rentaAgregar = false;
      this.usuario.privilegiosUsuario.rentaModificar = false;
      this.usuario.privilegiosUsuario.rentaCancelar = false;
      this.usuario.privilegiosUsuario.rentaEliminar = false;
      this.usuario.privilegiosUsuario.rentaConsultar = false;
      this.usuario.privilegiosUsuario.rentaAgregarBitacora = false;
      this.usuario.privilegiosUsuario.rentaConsultarBitacora = false;
      this.usuario.privilegiosUsuario.rentaConsultarPagos = false;
      this.usuario.privilegiosUsuario.rentaAgregarPagos = false;
      this.usuario.privilegiosUsuario.rentaModificarPagos = false;
      this.usuario.privilegiosUsuario.rentaEliminarPagos = false;
      this.usuario.privilegiosUsuario.rentasConsultar = false;
      this.usuario.privilegiosUsuario.rentasCorte = false;
      this.usuario.privilegiosUsuario.rentaGenerarTicket = false;

      //VENTAS
      this.usuario.privilegiosUsuario.ventaAgregar = false;
      this.usuario.privilegiosUsuario.ventaModificar = false;
      this.usuario.privilegiosUsuario.ventaEliminar = false;
      this.usuario.privilegiosUsuario.ventaConsultar = false;
      this.usuario.privilegiosUsuario.ventaGenerarTicket = false;
      this.usuario.privilegiosUsuario.ventasConsultar = false;
      this.usuario.privilegiosUsuario.ventasCorte = false;

      //PRODUCTOS
      this.usuario.privilegiosUsuario.productoAgregar = false;
      this.usuario.privilegiosUsuario.productoModificar = false;
      this.usuario.privilegiosUsuario.productoEliminar = false;
      this.usuario.privilegiosUsuario.productoConsultar = false;
      this.usuario.privilegiosUsuario.productosConsultar = false;
      this.usuario.privilegiosUsuario.productosFotosAgregar = false;
      this.usuario.privilegiosUsuario.productosFotosEliminar = false;
      this.usuario.privilegiosUsuario.productosFotosModificar = false;
      this.usuario.privilegiosUsuario.productosFotosConsultar = false;

      //CATALOGO PRODUCTOS
      this.usuario.privilegiosUsuario.catalogoProductoAgregar = false;
      this.usuario.privilegiosUsuario.catalogoProductoModificar = false;
      this.usuario.privilegiosUsuario.catalogoProductoEliminar = false;
      this.usuario.privilegiosUsuario.catalogoProductoConsultar = false;

      //PRECIOS PRODUCTO
      this.usuario.privilegiosUsuario.preciosProductoConsulta = false;
      this.usuario.privilegiosUsuario.preciosProductoModificar = false;

      //INVENTARIO PRODUCTO
      this.usuario.privilegiosUsuario.inventarioProductoAgregar = false;
      this.usuario.privilegiosUsuario.inventarioProductoModificar = false;
      this.usuario.privilegiosUsuario.inventarioProductoConsulta = false;

      //DISPONIBILIDAD
      this.usuario.privilegiosUsuario.disponibilidadConsulta = false;

      //CONJUNTOS
      this.usuario.privilegiosUsuario.conjuntoAgregar = false;
      this.usuario.privilegiosUsuario.conjuntoModificar = false;
      this.usuario.privilegiosUsuario.conjuntoEliminar = false;
      this.usuario.privilegiosUsuario.conjuntoConsultar = false;
      this.usuario.privilegiosUsuario.conjuntosConsultar = false;
      this.usuario.privilegiosUsuario.conjuntoProductoAgregar = false;
      this.usuario.privilegiosUsuario.conjuntoProductoEliminar = false;
      this.usuario.privilegiosUsuario.conjuntoProductoConsultar = false;

      //CLIENTES
      this.usuario.privilegiosUsuario.clienteAgregar = false;
      this.usuario.privilegiosUsuario.clienteModificar = false;
      this.usuario.privilegiosUsuario.clienteEliminar = false;
      this.usuario.privilegiosUsuario.clienteConsultar = false;
      this.usuario.privilegiosUsuario.clientesConsultar = false;

      //PARAMETROS EMPRESA
      this.usuario.privilegiosUsuario.parametrosEmpresaModificar = false;
      this.usuario.privilegiosUsuario.parametrosEmpresaConsultar = false;

      //OTROS CATÁLOGOS - Colores producto
      this.usuario.privilegiosUsuario.colorProductoAgregar = false;
      this.usuario.privilegiosUsuario.colorProductoModificar = false;
      this.usuario.privilegiosUsuario.colorProductoEliminar = false;
      this.usuario.privilegiosUsuario.colorProductoConsultar = false;
      this.usuario.privilegiosUsuario.coloresProductosConsultar = false;

      //OTROS CATÁLOGOS - Líneas producto
      this.usuario.privilegiosUsuario.lineaProductoAgregar = false;
      this.usuario.privilegiosUsuario.lineaProductoModificar = false;
      this.usuario.privilegiosUsuario.lineaProductoEliminar = false;
      this.usuario.privilegiosUsuario.lineaProductoConsultar = false;
      this.usuario.privilegiosUsuario.lineasProductoConsultar = false;

      //OTROS CATÁLOGOS - Marcas producto
      this.usuario.privilegiosUsuario.marcaProductoAgregar = false;
      this.usuario.privilegiosUsuario.marcaProductoModificar = false;
      this.usuario.privilegiosUsuario.marcaProductoEliminar = false;
      this.usuario.privilegiosUsuario.marcaProductoConsultar = false;
      this.usuario.privilegiosUsuario.marcasProductoConsultar = false;

      //OTROS CATÁLOGOS - Marcas producto
      this.usuario.privilegiosUsuario.tallaProductoAgregar = false;
      this.usuario.privilegiosUsuario.tallaProductoModificar = false;
      this.usuario.privilegiosUsuario.tallaProductoEliminar = false;
      this.usuario.privilegiosUsuario.tallaProductoConsultar = false;
      this.usuario.privilegiosUsuario.tallasProductoConsultar = false;

      //OTROS CATÁLOGOS - Tipos Producto
      this.usuario.privilegiosUsuario.tipoProductoAgregar = false;
      this.usuario.privilegiosUsuario.tipoProductoModificar = false;
      this.usuario.privilegiosUsuario.tipoProductoEliminar = false;
      this.usuario.privilegiosUsuario.tipoProductoConsultar = false;
      this.usuario.privilegiosUsuario.tiposProductoConsultar = false;
    },
  },
};
</script>
